import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from './dialog/dialog.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'startupForm';

  constructor(
    private dialog: MatDialog
  ) {
    this.dialog.open(DialogComponent, { disableClose: false, panelClass: 'custom-popup-class' })
  }

  clickHandle(e: any) {
    if (e.target.localName === 'app-dialog') {

    }
  }

}
